/**
 * Barrel exports for the shared UI layer.
 * This file re-exports approved shared primitives so feature screens can depend on one stable import path.
 */
export * from './ui-button/ui-button.component';
export * from './ui-button/ui-button.types';

export * from './ui-table/ui-table.component';
export * from './ui-table/ui-table.types';

export * from './ui-form-field/ui-form-field.component';
export * from './ui-form-field/ui-form-field.types';
export * from './ui-document-upload/ui-document-upload.component';
export * from './ui-document-upload/ui-document-upload.types';

export * from './ui-autocomplete-field/ui-autocomplete-field.component';
export * from './ui-autocomplete-field/ui-autocomplete-field.types';

export * from './ui-select/ui-select.component';
export * from './ui-select/ui-select.types';
export * from './ui-assignment-selector/ui-assignment-selector.component';

export * from './ui-modal/ui-modal.component';
export * from './ui-modal/ui-modal.types';

export * from './ui-dialog/ui-dialog.component';
export * from './ui-dialog/ui-dialog.types';

export * from './ui-badge/ui-badge.component';
export * from './ui-badge/ui-badge.types';

export * from './ui-card/ui-card.component';
export * from './ui-card/ui-card.types';

export * from './ui-stat-card/ui-stat-card.component';
export * from './ui-stat-card/ui-stat-card.types';

export * from './ui-sidebar/ui-sidebar.component';
export * from './ui-sidebar/ui-sidebar.types';

export * from './ui-topbar/ui-topbar.component';
export * from './ui-topbar/ui-topbar.types';

export * from './ui-page-header/ui-page-header.component';
export * from './ui-page-header/ui-page-header.types';

export * from './ui-page-tabs-header/ui-page-tabs-header.component';
export * from './ui-form-section/ui-form-section.component';
export * from './ui-form-action-footer/ui-form-action-footer.component';
export * from './ui-profile-avatar/ui-profile-avatar.component';

export * from './ui-chart/ui-chart.component';
export * from './ui-chart/ui-chart.types';

export * from './ui-pipeline-strip/ui-pipeline-strip.component';
export * from './ui-pipeline-strip/ui-pipeline-strip.types';

export * from './ui-filter-bar/ui-filter-bar.component';
export * from './ui-filter-bar/ui-filter-bar.types';

export * from './ui-toast/ui-toast.component';
export * from './ui-toast/ui-toast-outlet.component';
export * from './ui-toast/ui-toast.service';
export * from './ui-toast/ui-toast.types';

export * from './ui-stock-selector/ui-stock-selector.component';
export * from './ui-stock-selector/ui-stock-selector.types';
export * from './ui-stock-card-list/ui-stock-card-list.component';
export * from './ui-resource-summary/ui-resource-summary.component';

export * from './ui-address-form/ui-address-form.component';

export * from './ui-datepicker/ui-datepicker.component';

export * from './ui-toggle/ui-toggle.component';
export * from './ui-empty-state/ui-empty-state.component';
export * from './ui-label-translate.pipe';

export * from './ui-loader/ui-loader.service';
export * from './ui-loader/ui-loader-outlet.component';
